<script setup>
    defineProps({
        campaignData: {
            type: Object,
            required: true
        },
        carData: {
            type: Object,
            required: true
        }
    })
</script>

<template>
    <div class="section-banner">
        <div class="flex flex-col sm:flex-row items-center justify-center mx-auto">
            <figure class="w-1/2">
                <template v-if="campaignData.banner_image">
                    <img :src="campaignData.banner_image?.permalink" />
                </template>

                <template v-else>
                    <img :src="carData.feature_image?.url" />
                </template>
            </figure>

            <div class="text flex flex-col gap-8 items-center justify-center w-full md:w-1/2">
                <h1 class="text-center text-white" v-html="carData.title.replace(' ', '<br>')"></h1>

                <div class="bubble-text flex flex-col items-center justify-center rounded-full bg-brand2/90 px-6 py-4">
                    <p class="text-white">From</p>
                    <div class="price text-3xl font-bold text-white">
                        ${{ campaignData.cost_per_week }}
                    </div>
                    <p class="text-white">per week</p>
                </div>

                <div v-if="campaignData.extra_banner_text" class="extra-text max-w-md text-center">
                    <p>{{ campaignData.extra_banner_text }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

/* Import heavier Opens Sans fonts, and give them a different name because including the heavier weights across the whole site makes everything look weird. */

/* latin-ext */
@font-face {
  font-family: 'Open Sans Display';
  font-style: normal;
  font-weight: 300 800;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v44/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans Display';
  font-style: normal;
  font-weight: 300 800;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v44/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}


.section-banner {
    --bottom-height: clamp(1rem, -0.231rem + 6.838vw, 5rem);

    position: relative;
    max-height: 1200px;
    min-height: 300px;
    width:100%;
    padding-block:2rem;

    background-color: white;
    background: linear-gradient(to bottom, #a4c4f0 0%, #dfeaf9 60%, #ffffff 100%);

    h1 {
        font-family: 'Open Sans Display', 'Open Sans', sans-serif !important;
        font-size:clamp(3rem, 5vw, 3.6rem);
        font-weight:800 !important;
        line-height:1.1;
    }

    figure {
        position:relative;
        aspect-ratio: 1;
    }

    figure img {
        position: relative;
        inset: 0;
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    > div {
        max-width:1560px;
    }

    .bubble-text {
        aspect-ratio: 1/1;
        font-weight:bold;

        p {
            font-family: 'Open Sans Display', serif;
            font-weight:700;
            font-size:clamp(0.8rem, 2vw, 1.5rem);
        }

        .price {
            font-size:clamp(2rem, 5vw, 4rem);
            font-family: 'Open Sans Display', serif;
            font-weight:800;
            line-height:0.75;
        }
    }

    .extra-text {
        color:#2a48a6;
        font-size:clamp(1.25rem, 2vw, 1.5rem);
        font-family: 'Open Sans Display', serif;
        line-height: 1.4;
        font-weight:700;
        padding-inline:1rem;
        max-width:25rem;
    }

    @screen sm {
        figure img {
            position: relative;
            object-fit: contain;
            width: 100%;
            inset: auto;
        }
    }

    @screen xl {
        min-height: 0;
        padding-block:2rem;

        .banner-foreground-image {
            @apply absolute z-10 w-[31vw];
            left: 10vw;
        }
    }
}
</style>
